import { resolveColor } from 'ui/styles/utils/colors';
import styled, { ExecutionContext } from 'styled-components';
import { query } from 'ui/styles/queries';

export interface StyledSidebarProps {
  $wide?: boolean;
}

export const Sidebar = styled.div<StyledSidebarProps>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: flex-start;
  justify-content: flex-start;
  color: white;
  position: relative;
  min-height: 100vh;
  height: 100%; /* Allows sidebar to scale fully with tall page content */
  width: 100%;
  background-color: ${({ theme }) => resolveColor(theme, 'background')};
  flex: 0 0 ${({ theme }) => theme.sidebar.small}px;
  ${query.desktops`
    ${({ theme, $wide }: ExecutionContext & StyledSidebarProps) =>
      $wide ? `flex: 0 0 ${theme.sidebar.width}px;` : `flex: 0 0 ${theme.sidebar.small}px`};
  `}

  ${query.desktops`
    ${({ theme, $wide }: ExecutionContext & StyledSidebarProps) =>
      $wide ? `flex: 0 0 ${theme.sidebar.width}px;` : `flex: 0 0 ${theme.sidebar.small}px`};
  `}
`;

export const NavContainer = styled.div<StyledSidebarProps>`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex-grow: 1;
`;
